import { createSelector } from '@reduxjs/toolkit';

export const selectUser = (state) =>
  state?.talentManager || state?.creator || undefined;

export const selectUserId = createSelector(selectUser, (user) => user?.id);
